import { render, staticRenderFns } from "./Year06.vue?vue&type=template&id=181d6dea&scoped=true&"
import script from "./Year06.vue?vue&type=script&lang=js&"
export * from "./Year06.vue?vue&type=script&lang=js&"
import style0 from "./Year06.vue?vue&type=style&index=0&id=181d6dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d6dea",
  null
  
)

export default component.exports